import { Pipe } from '@angular/core';
var IsGreaterThanPipe = (function () {
    function IsGreaterThanPipe() {
    }
    IsGreaterThanPipe.prototype.transform = function (input, other) {
        return input > other;
    };
    return IsGreaterThanPipe;
}());
export { IsGreaterThanPipe };
IsGreaterThanPipe.decorators = [
    { type: Pipe, args: [{ name: 'isGreaterThan' },] },
];
/** @nocollapse */
IsGreaterThanPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-greater-than.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-greater-than.js
// module id = 223
// module chunks = 4